import ACTIONS , {FETCH_STATUS} from "../constants";

export const getPortfolioAttempt = {
  pending: {
    type: ACTIONS.PORTFOLIO.PENDING,
    status: FETCH_STATUS.LOADING,
  },
  success: (data) => ({
    type: ACTIONS.PORTFOLIO.SUCCESS,
    data,
    status: FETCH_STATUS.SUCCESS,
  }),
  error: (error) => ({
    type: ACTIONS.PORTFOLIO.ERROR,
    error,
    status: FETCH_STATUS.ERROR,
  }),
};

export const getPortFolio = (state) => ({
  type: ACTIONS.PORTFOLIO_CALL,
  payload: state,
});

// portfolio budget summary
export const getPortFolioBudgetSummaryAttempt = {
  pending: {
    type: ACTIONS.GET_PORTFOLIO_BUDGET_SUMMARY.PENDING,
    status: FETCH_STATUS.LOADING,
  },
  success: (data) => ({
    type: ACTIONS.GET_PORTFOLIO_BUDGET_SUMMARY.SUCCESS,
    data,
    status: FETCH_STATUS.SUCCESS,
  }),
  error: (error) => ({
    type: ACTIONS.GET_PORTFOLIO_BUDGET_SUMMARY.ERROR,
    error,
    status: FETCH_STATUS.ERROR,
  }),
};
export const getPortFolioBudgetSummary = (state) => ({
  type: ACTIONS.GET_PORTFOLIO_BUDGET_SUMMARY_CALL,
  payload: state,
});
// portfolio progress summary
export const getPortFolioProgressSummaryAttempt = {
  pending: {
    type: ACTIONS.GET_PORTFOLIO_PROGRESS_SUMMARY.PENDING,
    status: FETCH_STATUS.LOADING,
  },
  success: (data) => ({
    type: ACTIONS.GET_PORTFOLIO_PROGRESS_SUMMARY.SUCCESS,
    data,
    status: FETCH_STATUS.SUCCESS,
  }),
  error: (error) => ({
    type: ACTIONS.GET_PORTFOLIO_PROGRESS_SUMMARY.ERROR,
    error,
    status: FETCH_STATUS.ERROR,
  }),
};
export const getPortFolioProgressSummary = (state) => ({
  type: ACTIONS.GET_PORTFOLIO_PROGRESS_SUMMARY_CALL,
  payload: state,
});

export const createPortfolioAttempt = {
  pending: {
    type: ACTIONS.CREATE_PORTFOLIO.PENDING,
    status: FETCH_STATUS.LOADING,
  },
  success: (data) => ({
    type: ACTIONS.CREATE_PORTFOLIO.SUCCESS,
    data,
    status: FETCH_STATUS.SUCCESS,
  }),

  error: (error) => ({
    type: ACTIONS.CREATE_PORTFOLIO.ERROR,
    error,
    status: FETCH_STATUS.ERROR,
  }),
};

export const createPortFolioRequest = (state) => ({
  type: ACTIONS.CREATE_PORTFOLIO_CALL,
  payload: state,
});

// update portfolio request
export const updatePortfolioAttempt = {
  pending: {
    type: ACTIONS.UPDATE_PORTFOLIO.PENDING,
    status: FETCH_STATUS.LOADING,
  },
  success: (data) => ({
    type: ACTIONS.UPDATE_PORTFOLIO.SUCCESS,
    data,
    status: FETCH_STATUS.SUCCESS,
  }),
  error: (error) => ({
    type: ACTIONS.UPDATE_PORTFOLIO.ERROR,
    error,
    status: FETCH_STATUS.ERROR,
  }),
};

export const updatePortFolioRequest = (state) => ({
  type: ACTIONS.UPDATE_PORTFOLIO_CALL,
  payload: state,
});

export const getPortFolioDetailsAttempt = {
  pending: {
    type: ACTIONS.GET_PORTFOLIO_DETAILS.PENDING,
    status: FETCH_STATUS.LOADING,
  },
  success: (data) => ({
    type: ACTIONS.GET_PORTFOLIO_DETAILS.SUCCESS,
    data,
    status: FETCH_STATUS.SUCCESS,
  }),
  error: (error) => ({
    type: ACTIONS.GET_PORTFOLIO_DETAILS.ERROR,
    error,
    status: FETCH_STATUS.ERROR,
  }),
};

export const getPortFolioDetails = (state) => ({
  type: ACTIONS.GET_PORTFOLIO_DETAILS_CALL,
  payload: state,
});

export const sortPortfoliosAttempt = {
  pending: {
    type: ACTIONS.SORT_PORTFOLIOS.PENDING,
    status: FETCH_STATUS.LOADING,
  },
  success: (data) => ({
    type: ACTIONS.SORT_PORTFOLIOS.SUCCESS,
    data,
    status: FETCH_STATUS.SUCCESS,
  }),
  error: (error) => ({
    type: ACTIONS.SORT_PORTFOLIOS.ERROR,
    error,
    status: FETCH_STATUS.ERROR,
  }),
};

export const sortPortfoliosRequest = (state) => ({
  type: ACTIONS.SORT_PORTFOLIOS_CALL,
  payload: state,
});

export const deletePortfolioAttempt = {
  pending: {
    type: ACTIONS.DELETE_PORTFOLIOS.PENDING,
    status: FETCH_STATUS.LOADING,
  },
  success: (data) => ({
    type: ACTIONS.DELETE_PORTFOLIOS.SUCCESS,
    data,
    status: FETCH_STATUS.SUCCESS,
  }),
  error: (error) => ({
    type: ACTIONS.DELETE_PORTFOLIOS.ERROR,
    error,
    status: FETCH_STATUS.ERROR,
  }),
};

export const deletePortfoliosRequest = (state) => ({
  type: ACTIONS.DELETE_PORTFOLIOS_CALL,
  payload: state,
});

export const updatePortfolioFlagAttempt = {
  pending: {
    type: ACTIONS.PORTFOLIO_FLAG.PENDING,
    status: FETCH_STATUS.LOADING,
  },
  success: (data) => ({
    type: ACTIONS.PORTFOLIO_FLAG.SUCCESS,
    data,
    status: FETCH_STATUS.SUCCESS,
  }),
  error: (error) => ({
    type: ACTIONS.PORTFOLIO_FLAG.ERROR,
    error,
    status: FETCH_STATUS.ERROR,
  }),
};

export const updatePortfolioFlag = (state) => ({
  type: ACTIONS.PORTFOLIO_FLAG_CALL,
  payload: state,
});


